import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.scss';

function AccountMenuItem({
  children, icon, iconAlt, onClick, important,
}) {
  return (
    <li className={classNames(styles.wrapper, { [styles.important]: important })}>
      <button type="button" onClick={onClick} className={styles.item}>
        <span className={styles.label}>
          {children}
        </span>
        {icon && <img src={icon} alt={iconAlt} className={styles.image} />}
      </button>
    </li>
  );
}

AccountMenuItem.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
  icon: PropTypes.string,
  iconAlt: PropTypes.string,
  important: PropTypes.bool,
};

AccountMenuItem.defaultProps = {
  onClick: null,
  children: null,
  icon: null,
  iconAlt: '',
  important: false,
};

export default AccountMenuItem;



// WEBPACK FOOTER //
// ./src/app/components/NavigationBar/components/AccountMenuItem/index.js